import request from '@/utils/request'

/**
 * 获取金币账户列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listGold(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.listGold',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 申请金币提现
 * @param {Object} data 提现数据
 * @returns {Promise} Promise对象
 */
export function applyGoldWithdrawal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.applyGoldWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}